// Ricerca predittiva nell'header: chiede a Shopify la sezione "predictive-search" mentre si scrive.
// Frecce su/giù scorrono i suggerimenti, Invio apre quello evidenziato, Esc chiude.
document.querySelectorAll('[data-predictive]').forEach(function (form) {
  var input = form.querySelector('input[name=q]');
  var box = form.querySelector('.predictive');
  var timer, ctrl, active = -1;
  function items() { return box.querySelectorAll('[role=option]'); }
  function close() {
    box.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
  }
  function mark(i) {
    var list = items();
    if (!list.length) return;
    active = (i + list.length) % list.length;
    list.forEach(function (el, n) { el.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
    input.setAttribute('aria-activedescendant', list[active].id);
    list[active].scrollIntoView({ block: 'nearest' });
  }
  function load() {
    var q = input.value.trim();
    if (q.length < 2) return close();
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var url = form.dataset.url + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=4&resources[options][prefix]=last&section_id=predictive-search';
    fetch(url, { signal: ctrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var res = html.querySelector('[data-ps-results]');
        if (!res) return close();
        box.innerHTML = res.innerHTML;
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        active = -1;
      })
      .catch(function (e) { if (e.name !== 'AbortError') console.error(e); });
  }
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(load, 250); });
  input.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
    else if (e.key === 'Escape') { close(); }
    else if (e.key === 'Enter' && active > -1) { e.preventDefault(); location.href = items()[active].querySelector('a').href; }
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
});
